<template>
  <div class="leftCardContainer">
    <div class="rightSideTitleActions">
      <span class="leftTitle">{{ $t("Warehouse") }}</span>
      <div class="actionsContainer">
        <div class="searchContainer">
          <v-icon> search </v-icon>
          <InputField inputType="text" :value="search" :placeholder="$t('Search')" :inputStyle="{
            borderRadius: '0px',
            width: '130px',
            borderTop: 'none',
            borderRight: 'none',
            borderLeft: 'none',
            borderBottom: '1px solid rgba(118, 118, 118, 0.50)',
          }" @input="handleSearch($event)" />
        </div>
        <CustomButton icon="delete" :width="'20px'" :height="'20px'" :iconSize="12" :disabled="selectedRows.length === 0"
          :buttonStyling="{ padding: '8px', marginRight: '5px', borderRadius: '4px' }" @buttonClick="openDeleteDialog" />
        <CustomButton icon="download" :width="'20px'" :height="'20px'" :iconSize="12"
          :buttonStyling="{ padding: '8px', marginRight: '5px', borderRadius: '4px' }" @buttonClick="handleDownload" :disabled="downloadDisable" :isLoading="downloadDisable" />
        <CustomButton icon="cloud_upload" :width="'20px'" :height="'20px'" :iconSize="12"
          :buttonStyling="{ padding: '8px', marginRight: '5px', borderRadius: '4px' }" @buttonClick="handleCloudDownload" />
        <CustomButton icon="add" :width="'20px'" :height="'20px'" :iconSize="12" :disabled="userIsCreatingOrEditingData"
          :buttonStyling="{ padding: '8px', marginRight: '5px', borderRadius: '4px' }" @buttonClick="handleAdd" />
      </div>
    </div>
    <div class="tabsContainer">
      <Tabs :activeTab="activeTab" :tabs="getTabs" @startTabChange="handleTabChange" />
    </div>
    <div class="tableDivContainer">
      <Table :checkbox="true" :loading="loading" :headers="headers" :items="materials" :sortable="true"
        @onScrollBottom="onScrollBottom" @onScrollTop="onScrollTop" @sortClick="onSortClick" :emitRowClickBusEvent="!userIsCreatingOrEditingData"
        @selectedRows="onCheckboxClick($event)" />
    </div>
    <DialogContent :isOpen="dialog" :isPersistent="false" :onClose="closeDialog">
      <template v-slot:content>
        <div style="height: 100%;">
          <div class="tabs-custom">
            <Tabs :tabs="tabsDialog" :activeTab="activeTabDialog" @startTabChange="handleTabChangeDialog"
              style="display: flex; align-items: left; " />
          </div>
          <div class="tabs-content-custom" v-if="activeTabDialog === 0">
            <span class="span-custom">Material Family</span>
            <InputField :inputStyle="{
              backgroundColor: 'white',
            }" inputType="text" value="All Families" size="large" :inputDisabled="true"></InputField>
            <InputField :inputStyle="{
              color: '#767676 !important',
            }" inputType="file" size="large" :fileTypes="fileTypes" :value="file" @input="updateFile($event)">
            </InputField>
            <div class="buttons-container-custom">
              <div style="display: flex">
                <CustomButton :label="$t('Download Materials')" :width="'4.48438rem'"
                  :button-styling="customButtonStylesExtra" @buttonClick="handleExtraAction"></CustomButton>
              </div>
              <div style="display: flex">
                <CustomButton :label="$t('Cancel')" :width="'2.74219rem'" :button-color="'#FFF'" :label-color="'#29BDF0'"
                  :buttonStyling="customButtonStylesSecondary" @buttonClick="handleSecondaryAction"></CustomButton>
                <CustomButton :label="$t('Submit')" :width="'2.74219rem'" :button-styling="customButtonStylesMain"
                  @buttonClick="handleMainAction(file)">
                </CustomButton>
              </div>
            </div>
          </div>
          <div class="table-buttons-custom" v-if="activeTabDialog === 1">
            <div class="table-custom">
              <Table :loading="loading" :headers="headersDialog" :items="history"></Table>
            </div>
            <div>
              <div style="display: flex; justify-content: flex-end">
                <CustomButton :buttonStyling="customButtonStylesSecondary" :label="$t('Close')"
                  @buttonClick="handleSecondaryAction">
                </CustomButton>
              </div>
            </div>
          </div>
        </div>
        <LoadingSpinner :active.sync="loadingUpload" :is-full-page="false" color="#29bdf0" />
      </template>
    </DialogContent>
    <dialog-choice
      :isOpen="deleteDialogIsOpen"
      :title="$t('DeleteMaterial')"
      :content="$t('DeleteMaterialConfirmation')"
      :mainActionLabel="$t('Confirm')"
      @mainAction="handleDelete"
      :secondaryActionLabel="$t('Cancel')"
      @secondaryAction="deleteDialogIsOpen = false"
      icon="mdi-delete"
      iconColor="#29BDF0"
    />
    <dialog-choice
      :isOpen="discardChangesByTabChangeDialogIsOpen"
      :title="$t('DiscardChanges')"
      :content="$t('DiscardChangesByTabSwitchDialog')"
      :mainActionLabel="$t('Confirm')"
      @mainAction="tabChange"
      :secondaryActionLabel="$t('Cancel')"
      @secondaryAction="cancelTabChange"
      icon="mdi-delete"
      iconColor="#29BDF0"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { bus } from "@/main.js";
import ManagementPage from "@/newComponents/_Organisms/ManagementPage.vue";
import Table from "@/newComponents/_Molecules/Table.vue";
import CustomButton from "@/newComponents/_Atoms/CustomButton.vue";
import InputField from "@/newComponents/_Atoms/InputField.vue";
import Tabs from "@/newComponents/_Atoms/Tabs.vue";
import DialogContent from "@/newComponents/_Molecules/DialogContent.vue";
import LoadingSpinner from "vue-loading-overlay";
import DialogChoice from '@/newComponents/_Molecules/DialogChoice.vue';

export default {
  name: "TableView",

  components: {
    Table,
    ManagementPage,
    CustomButton,
    InputField,
    Tabs,
    DialogContent,
    LoadingSpinner,
    DialogChoice,
  },
  props: {
    selectedMaterials: {
      type: Object,
    },
  },

  data() {
    return {
      discardChangesByTabChangeDialogIsOpen: false,
      indexTochange: null,
      dialog: false,
      deleteDialogIsOpen: false,
      loadingUpload: false,
      activeTabDialog: 0,
      tabsDialog: [
        {
          label: this.$i18n.tc('Import', 1),
        },
        {
          label: this.$i18n.tc('History', 1),
        },
      ],
      value: null,
      fileTypes: [".xlsx"],
      type: "normal",

      headersDialog: [
        {
          text: this.$i18n.tc('UploadDate', 1),
          varName: "updated_at",
        },
        {
          text: this.$i18n.tc('MaterialFamily', 1),
          varName: "materialFamily",
        },
        {
          text: this.$i18n.tc('FileName', 1),
          varName: "original_file_name",
        },
        {
          text: this.$i18n.tc('Status', 1),
          varName: "status",
        },
      ],
      history: [],
      downloadDisable: false,
      file: [],
      search: null,
      activeTab: 0,
      loading: false,
      materialFamily: "ca",
      scrollTop: 0,
      sortOrder: null,
      scrollHeight: 0,
      selectedRows: [],
      tabs: [
        {
          label: this.$i18n.tc('Cable', 1),
          materialFamily: "ca",
        },
        {
          label: this.$i18n.tc('Closure', 1),
          materialFamily: "cl",
        },
        {
          label: this.$i18n.tc('Equipment', 1),
          materialFamily: "sp",
        },
        {
          label: this.$i18n.tc('Pole', 1),
          materialFamily: "pl",
        },
        {
          label: this.$i18n.tc('Chamber', 1),
          materialFamily: "ch",
        },
        {
          label: this.$i18n.tc('Cabinet', 1),
          materialFamily: "cb",
        },
        {
          label: this.$i18n.tc('TobyBox', 1),
          materialFamily: "tb",
        },
        {
          label: this.$i18n.tc('Pathway', 1),
          materialFamily: "pt",
        },
        {
          label: this.$i18n.tc('TechnicalSite', 1),
          materialFamily: "ts",
        },
        {
          label: this.$i18n.tc('Conduct', 1),
          materialFamily: "cd",
        },
        {
          label: this.$i18n.tc('Bundle', 1),
          materialFamily: "ud",
        },
        {
          label: this.$i18n.tc('Accessory', 1),
          materialFamily: "ac",
        },
        {
          label: this.$i18n.tc('Other', 1),
          materialFamily: "ot",
        },
        {
          label: this.$i18n.tc('Rack', 1),
          materialFamily: "rc",
        },
        {
          label: this.$i18n.tc('Drawer', 1),
          materialFamily: "dw",
        },
        {
          label: this.$i18n.tc('Cassete', 1),
          materialFamily: "ct",
        },
      ],
      pageNumber: 1,
      pagination: 25,
      currentPageTop: 1,
      currentPageBot: 1,
      lastPage: 2,
      headers: [
        { text: this.$i18n.tc('CodeReference', 1), varName: "sm_reference" },
        { text: this.$i18n.tc('ShortDescription', 1), varName: "sm_short_description" },
        { text: this.$i18n.tc('Description', 1), varName: "sm_description" },
        { text: this.$i18n.tc('Vendor', 1), varName: "sm_vendor" },
        { text: this.$i18n.tc('Manufactor', 1), varName: "sm_manufacturer" },
        { text: this.$i18n.tc('LaborPrice', 1), varName: "sm_labor_price" },
        { text: this.$i18n.tc('PricePerUnit', 1), varName: "sm_unit_price" },
        { text: this.$i18n.tc('UnitaryValue', 1), varName: "sm_unitary_value" },
      ],
      materials: [],
      customButtonStylesSecondary: {
        'marginRight': '10px',
        'marginTop': '10px',
        'boxShadow': 'none',
        'border': '1px solid #29BDF0',
        'border-radius': '7px',
        'font-size': '0.4375rem',
        'line-height': '0.75rem',
        'height': '20px',
        'font-weight': '600'
      },
      customButtonStylesMain: {
        'marginTop': '10px',
        'boxShadow': 'none',
        'border': '1px solid #29BDF0',
        'border-radius': '7px',
        'font-size': '0.4375rem',
        'line-height': '0.75rem',
        'height': '20px',
        'font-weight': '600'
      },
      customButtonStylesExtra: {
        'marginTop': '10px',
        'boxShadow': 'none',
        'border': '1px solid #29BDF0',
        'border-radius': '7px',
        'font-size': '0.4375rem',
        'line-height': '0.75rem',
        'height': '20px',
        'font-weight': '600'
      },
      userIsCreatingOrEditingData: false,
    };
  },

  mounted() {
    this.loadHistory();
    this.getInitialMaterials();
    bus.$on("reload-materials", () => this.getInitialMaterials())
    bus.$on("toggle-create-edit-flag", () => this.userIsCreatingOrEditingData = !this.userIsCreatingOrEditingData)
  },

  destroyed() {
    bus.$off("reload-materials");
    bus.$off("toggle-create-edit-flag");
  },

  watch: {
    activeTabDialog(value) {
      if (value === 1) {
        this.loadHistory();
      }
    }
  },

  computed: {
    getTabs() {
      const materialFamilies = this.$store.getters.optionLists_materialFamily;
      return materialFamilies.map(family => { 
        const i18nKey = family.name ? family.name.replace(/\s+/g, '') : '';
        return {
          label: this.$i18n.tc(i18nKey, 1),
          materialFamily: family.code
        };
      });
    },
  },

  methods: {
    ...mapActions(["fetchStockMaterialsListObject", "getHistory", "DELETE_MATERIAL_ITEMS", "downloadAll", "importMaterialFamilies"]),

    handleTabChangeDialog(index) {
      this.activeTabDialog = index;
    },

    async loadHistory() {
      try {
        const history = await this.getHistory();
        this.history = history;
        this.history = history.map((item) => ({
          ...item,
          materialFamily: item.material_family || "All Families",
        }))
      } catch (e) {
        console.error(e);
      }
    },

    closeDialog() {
      this.dialog = false;
    },

    async handleMainAction() {
      this.loadingUpload = true;

      try {

        let formData = new FormData();

        formData.append("file", this.file);
        formData.append("file_type", "xlsx");

        // Make the HTTP request to upload the file
        await this.importMaterialFamilies(formData);

        this.$toasted.global.toast_success(this.$i18n.t("FileUploadedSuccessfully"));
      } catch (e) {
        console.error(e);
        this.$toasted.global.toast_error(this.$i18n.t("FileUploadError"));
      } finally {
        this.loadingUpload = false;
        bus.$emit("clear-drop-button-file")
        this.closeDialog();
        this.getInitialMaterials();
      }
    },

    handleSecondaryAction() {
      bus.$emit("clear-drop-button-file")
      this.closeDialog();
      setTimeout(() => {
        this.activeTabDialog = 0;
      }, 1000);
    },
    handleExtraAction() {
      this.handleDownload();
    },

    updateFile(e) {
      this.file = e
    },

    async getInitialMaterials() {
      this.loading = true;
      this.currentPageBot = 1
      this.currentPageTop = 1
      let queryParams = {
        "page[number]": 1,
        paginate: 25,
        material_family_id: this.materialFamily,
      };

      if (this.search !== null) {
        queryParams["filter[search]"] = this.search;
      }

      if (this.sortOrder !== null) {
        queryParams["sort"] = this.sortOrder;
      }

      const materialsObject = await this.fetchStockMaterialsListObject(queryParams);
      this.materials = materialsObject.data;
      this.lastPage = materialsObject.meta.last_page;
      this.loading = false;
    },

    async getMaterialsBottom() {
      this.loading = true;
      this.pagination = 25;
      if (this.materials.length >= 75) {
        this.currentPageTop++;
      }
      this.currentPageBot++;

      let queryParams = {
        "page[number]": this.currentPageBot,
        paginate: this.pagination,
        material_family_id: this.materialFamily,
      };

      if (this.search !== null) {
        queryParams["filter[search]"] = this.search;
      }

      if (this.sortOrder !== null) {
        queryParams["sort"] = this.sortOrder;
      }

      const materialsObject = await this.fetchStockMaterialsListObject(queryParams);
      this.lastPage = materialsObject.meta.last_page;
      const allMaterials = [...this.materials, ...materialsObject.data];
      this.materials = Array.from(new Set(allMaterials.map(a => a.sm_id)))
        .map(id => { return allMaterials.find(a => a.sm_id === id) })
      if (this.materials.length > 75) {
        this.materials = this.materials.slice(this.materials.length - 75);
      }

      const currentScroll = document.getElementById("scroll-bar").scrollTop;
      this.loading = false;

      const rowElement = document.getElementById("rowId");
      if (rowElement) {
        const rowHeight = rowElement.clientHeight;
        for (let i = 0; i < 2; i++) {
          const offset = rowHeight * i;
          document.getElementById("scroll-bar").scrollTo({
            top: currentScroll - offset,
            behavior: "smooth",
          });
        }
      }
    },

    async getMaterialsTop() {
      this.loading = true;
      this.pagination = 25;
      this.currentPageTop--;

      let queryParams = {
        "page[number]": this.currentPageTop,
        paginate: this.pagination,
        material_family_id: this.materialFamily,
      };

      if (this.search !== null) {
        queryParams["filter[search]"] = this.search;
      }

      if (this.sortOrder !== null) {
        queryParams["sort"] = this.sortOrder;
      }

      const materialsObject = await this.fetchStockMaterialsListObject(queryParams);
      this.lastPage = materialsObject.meta.last_page;
      const allMaterials = [...materialsObject.data, ...this.materials];
      this.materials = Array.from(new Set(allMaterials.map(a => a.sm_id)))
        .map(id => { return allMaterials.find(a => a.sm_id === id) })
      if (this.materials.length > 75) {
        this.materials.splice(-(this.materials.length - 75));
        this.currentPageBot--;
      }

      const currentScroll = document.getElementById("scroll-bar").scrollTop;
      this.loading = false;

      const rowElement = document.getElementById("rowId");
      if (rowElement) {
        const rowHeight = rowElement.clientHeight;
        for (let i = 0; i < 25; i++) {
          const offset = rowHeight * i;
          document.getElementById("scroll-bar").scrollTo({
            top: currentScroll + offset,
            behavior: "smooth",
          });
        }
      }
    },

    onCheckboxClick(event) {
      this.selectedRows = event.map(row => ({ uuid: row.sm_uuid }));
    },

    handleSearch: _.debounce(function (event) {
      if (event === "") {
        this.search = null;
      } else {
        this.search = event;
      }
      this.materials = [];
      this.getInitialMaterials();
    }, 1000),

    onScrollBottom() {
      if (this.currentPageBot !== this.lastPage) {
        this.pageNumber++;
        this.getMaterialsBottom();
      }
    },

    onScrollTop() {
      if (this.currentPageTop !== 1) {
        this.pageNumber--;
        this.getMaterialsTop();
      }
    },

    onSortClick(sortOrder, index) {
      this.materials = []
      if (sortOrder === "asc") {
        this.sortOrder = this.headers[index].varName;
      } else if (sortOrder === "desc") {
        this.sortOrder = `-${this.headers[index].varName}`;
      } else {
        this.sortOrder = sortOrder;
      }
      this.getInitialMaterials();
    },
    
    async handleDelete() {
      try {
        if (this.selectedRows.length >= 1) {
          await this.DELETE_MATERIAL_ITEMS(this.selectedRows)
          bus.$emit("clear-SelectedItems")
          this.$emit('clear-selected-item')
          this.selectedRows = [];
          this.getInitialMaterials()
          this.deleteDialogIsOpen = false
        }
      } catch (e) {
        console.error(e);
      }
    },

    async handleDownload() {
      try {
        this.downloadDisable = true;
        let data = await this.downloadAll();
        window.open(data.file_url_public);
      } catch (e) {
        console.error(e);
      } finally {
        this.downloadDisable = false;
      }
    },

    handleCloudDownload() {
      this.dialog = true;
    },

    handleAdd() {
      this.$emit('open-create-material-form')
    },

    handleTabChange(index) {
      let isCreating = this.isCreatingMaterial();
      this.indexTochange = index;
      if(isCreating){
        this.discardChangesByTabChangeDialogIsOpen = true;
      } else {
        this.tabChange(index);
      }
    },

    isCreatingMaterial() {
      if(this.selectedMaterials === null){
        return false;
      }
      if (Object.keys(this.selectedMaterials).length > 0) {
        return false;
      }
      return true;
    },

    tabChange() {
      this.discardChangesByTabChangeDialogIsOpen = false;
      this.activeTab = this.indexTochange;
      this.$emit('change-tab', this.getTabs[this.indexTochange].materialFamily);
      bus.$emit("clear-SelectedItems")
      this.selectedRows = [];
      this.materialFamily = this.getTabs[this.indexTochange].materialFamily;
      this.getInitialMaterials();
    },

    cancelTabChange(){
      this.discardChangesByTabChangeDialogIsOpen = false;
      bus.$emit('re-render');
    },

    openDeleteDialog(){
      if (this.selectedRows && this.selectedRows.length === 0) {
      } else {
        this.deleteDialogIsOpen = true;
      }
    },
  },
};
</script>

<style scoped>
.searchContainer {
  display: flex;
  align-items: center;
}

.tableDivContainer {
  height: 87%;
  margin-top: 5px;
}

.tabsContainer {
  height: 8%;
  display: flex;
  margin-top: 5px;
}

.leftCardContainer {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  padding: 20px 28px;
}

.actionsContainer {
  display: flex;
  align-items: center;
  gap: 3px;
}

.leftTitle {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  line-height: 20px;
  text-transform: uppercase;
}

.rightSideTitleActions {
  height: 5%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.buttons-container-custom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 20px;
}

.cancel-button-custom {
  background: transparent;
  border-radius: 0.25rem;
  border: 0.609px solid #29bdf0;
}

.leftCardContainer {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  padding: 20px 28px;
}

.actionsContainer {
  display: flex;
  align-items: center;
  gap: 3px;
}

.leftTitle {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  line-height: 20px;
  /* 200% */
  text-transform: uppercase;
}

.rightSideTitleActions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.layer-search {
  flex: 0 0 auto;
  font-size: 12px;
  margin-right: 5px;
}

.layers-search .v-input__slot {
  min-height: 0 !important;
}

.layers-search .v-label {
  top: 4px !important;
  font: normal normal normal 12px/16px Segoe UI;
  color: #b1b6b9;
}

.span-custom {
  display: flex;
  padding: 0px 20px;
  color: #767676;
  font-family: Lato;
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.9375rem;
}

.tabs-custom {
  padding: 0px 20px;
}

.table-custom {
  height: 90%;
}

.table-buttons-custom {
  height: 70%;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/StockManagement/TableView.vue